import React from 'react';

const SvgXIcon = (props) => (
  <svg viewBox="0 0 10 10" width="1em" height="1em" {...props} id="XIcon">
    <path
      d="M5 0C2.3 0 .1 2.3.1 5S2.3 9.9 5 9.9 9.9 7.7 9.9 5 7.7 0 5 0zm3.2 7.4l-.8.8-2.5-2.4-2.4 2.4-.8-.8L4.1 5 1.7 2.6l.8-.8 2.4 2.4 2.4-2.4.8.8L5.8 5l2.4 2.4z"
      fill="currentColor"
    />
  </svg>
);

export default SvgXIcon;
